jQuery( document ).ready(function(){
    if(jQuery("#aw_login_pwd").length){
        jQuery('#aw_login_pwd').keypress(function(event){
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                jQuery('#aw_login_button').click();
            }
        });
    }
    if(jQuery("#aw_login_email").length){
        jQuery('#aw_login_email').keypress(function(event){
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                setTimeout(function(){
                    jQuery('#aw_login_pwd').click();
                    jQuery("#aw_login_pwd").focus();
                    jQuery("#aw_login_pwd").select();
                }, 500);
            }
        });
    }
});